<template>
    <v-dialog
        v-model="showDialog"
        width="700"
    >
        <v-card>
            <v-card-title style="background-color: #009688; color: white;">
                History for: {{ data && data.ACCT_M }}
            </v-card-title>
            <v-card-text>
                <v-tabs
                    v-model="tab"
                    background-color="transparent"
                    dark
                    slider-size="4"
                >
                    <v-tabs-slider color="teal darken-1" />
                    <v-tab href="#tab-1" class="teal--text text--darken-1">
                        Active
                    </v-tab>
                    <v-tab href="#tab-2" class="teal--text text--darken-1">
                        Provision
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1" :transition="false">
                        <v-card flat>
                            <v-card-text>
                                <v-textarea
                                    v-model="dataCopy.ACTIVE_HISTORY"
                                    placeholder="Nothing to show."
                                    hide-details
                                    :readonly="true"
                                    outlined
                                    color="teal darken-1"
                                />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2" :transition="false">
                        <v-card flat>
                            <v-card-text>
                                <v-textarea
                                    v-model="dataCopy.PROVISION_HISTORY"
                                    placeholder="Nothing to show."
                                    hide-details
                                    :readonly="true"
                                    outlined
                                    color="teal darken-1"
                                />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="teal darken-1 white--text" @click="showDialog = false">
                    close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['show', 'data'],
    data: ()=>({
        tab: null,
        dataCopy: {
            ACTIVE_HISTORY: null,
            PROVISION_HISTORY: null
        }
    }),
    computed: {
        showDialog: {
            get() {
                this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        initData() {
            if (this.data) {
                this.dataCopy = structuredClone(this.data)
            }
        }
    }
}
</script>
